export default {
    name: "NewBusinessQuestionSets",
    props: {
        title: String,
        question: String,
        additionalText: String,
        nswText: Boolean,
        buttonValue: Boolean,
        questionSetSubmitted: Boolean,
        parent: Object
    },
    data: {
        activeClass: 'text-lg-center response-status is_active',
        inactiveClass: 'text-lg-center response-status',
    },
    methods: {
        checkStoreData() {
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        initApp() {
            this.checkStoreData();
        },
        backToPrevious() {
            switch(this.title) {
                case 'Previous policies':
                break;

                case 'Previous claims':
                    this.parent.previousPoliciesSubmitted = false;
                break;

                case 'Existing claims':
                    this.parent.previousClaimsSubmitted = false;
                break;


                case 'NSW Small Business Exemption':
                break;
            }

            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        setDeclarations($value) {
            switch(this.title) {
                case 'Previous policies':
                    this.previousPoliciesAnswer = $value;
                    this.$emit('previousPoliciesDeclaration', $value);
                break;

                case 'Previous claims':
                    this.previousClaimsAnswer = $value;
                    this.$emit('previousClaimsDeclaration', $value);
                break;

                case 'Existing claims':
                    this.existingClaimsAnswer = $value;
                    this.$emit('existingClaimsDeclaration', $value);
                break;


                case 'NSW Small Business Exemption':
                    this.$emit('nswSmallBusinessExemptionDeclaration', $value);
                break;
            }
            
        }
    },
    mounted() {
        this.initApp();
    }
}